/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Heading_No_CardInputs */



/**
* | output |
* | --- |
* | "No card at this address" |
*
* @param {Error_Notfound_Heading_No_CardInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_heading_no_card = /** @type {((inputs?: Error_Notfound_Heading_No_CardInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Heading_No_CardInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Karte unter dieser Adresse")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune carte à cette adresse")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("这个地址上没有卡牌")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("這個網址上沒有卡牌")
	if (locale === "ko") return /** @type {LocalizedString} */ ("이 주소에는 카드가 없습니다")
	return /** @type {LocalizedString} */ ("No card at this address")
});